/**
 * A generic type for paginated data
 */
type ArraySlice<T> = (array: T[], currentPage: number, pageSize: number) => T[];

/**
 * Method that helps getting the paginated information from any array
 * @param array the array provided to be sliced
 * @param currentPage the current page of the pagination
 * @param pageSize the size of the shown information
 * @returns a slice of the information to be set as the paginated data
 */
export const getPaginatedSlice: ArraySlice<any> = (array, currentPage, pageSize) => {
    if (array.length === 0) return [];
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = array.slice(startIndex, endIndex);
    return paginatedData;
};